import { render, staticRenderFns } from "./competitionLiveSettingList.vue?vue&type=template&id=7406f462&scoped=true"
import script from "./competitionLiveSettingList.vue?vue&type=script&lang=ts"
export * from "./competitionLiveSettingList.vue?vue&type=script&lang=ts"
import style0 from "./competitionLiveSettingList.vue?vue&type=style&index=0&id=7406f462&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406f462",
  null
  
)

export default component.exports